export const WARD_SELECTION = `
    id
    name
    wardCode
    provinceCode
`;
